import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterTeacherRoutingModule } from './register-teacher-routing.module';
import { RegisterTeacherComponent } from './register-teacher.component';
import { ComponentsModule } from '../../../components/components.module';
import { MatStepperModule } from '@angular/material/stepper';
import { PreRegisterTeacherComponent } from '../pre-register-teacher/pre-register-teacher.component';

@NgModule({
  declarations: [RegisterTeacherComponent, PreRegisterTeacherComponent],
  imports: [
    CommonModule,
    RegisterTeacherRoutingModule,
    ComponentsModule,
    MatStepperModule,
    ],
})
export class RegisterTeacherModule {}
